/**
 * Legal / ticket interest % lives on Article Master as `percentage`.
 * Gold article is the default; a pledge line's article wins when selected.
 */

export function pickGoldArticleRate(articles) {
  if (!Array.isArray(articles)) return null;
  let best = null;
  let bestScore = -1;
  for (const article of articles) {
    const title = String(article.title || '').toLowerCase();
    if (!title.includes('gold')) continue;
    let score = 50;
    if (title === 'gold') score = 100;
    else if (title.includes('ornament')) score = 90;
    else if (title.includes('coin')) score = 70;
    if (score > bestScore) {
      bestScore = score;
      best = article;
    }
  }
  if (!best || best.percentage == null) return null;
  const n = Number(best.percentage);
  return Number.isFinite(n) ? n : null;
}

export function articleRateById(articles, articleId) {
  if (!articleId || !Array.isArray(articles)) return null;
  const found = articles.find((a) => String(a._id) === String(articleId));
  if (!found || found.percentage == null) return null;
  const n = Number(found.percentage);
  return Number.isFinite(n) ? n : null;
}

/** Rate to show on tickets / All Pledges — Article Master only. */
export function resolveArticleMasterRate(masterArticles, pledgeOrLines) {
  const lines = Array.isArray(pledgeOrLines)
    ? pledgeOrLines
    : pledgeOrLines?.articles;
  if (Array.isArray(lines)) {
    for (const line of lines) {
      const id = line?.articleId || line?.article_id;
      const rate = articleRateById(masterArticles, id);
      if (rate != null) return rate;
    }
  }
  return pickGoldArticleRate(masterArticles);
}

export function formatArticleMasterRate(masterArticles, pledgeOrLines, empty = 'N/A') {
  const rate = resolveArticleMasterRate(masterArticles, pledgeOrLines);
  return rate == null ? empty : `${rate}%`;
}
